import { FC } from 'react';
import { Price } from 'src/features/pricing/components/price';
import { StyledCenteredContent } from '../../star-wars-modal.styles';
import { StyledMessage, StyledOldPrice, StyledPrice, StyledText } from './discount-message.styles';
import { DiscountMessageProps } from './discount-message.types';
export const DiscountMessage: FC<DiscountMessageProps> = ({
  price,
  discountedPrice,
  symbol
}) => <StyledCenteredContent data-sentry-element="StyledCenteredContent" data-sentry-component="DiscountMessage" data-sentry-source-file="discount-message.tsx">
    <StyledMessage data-sentry-element="StyledMessage" data-sentry-source-file="discount-message.tsx">
      Start your cyber career today - for only{' '}
      <StyledOldPrice price={price} symbol={symbol} data-sentry-element="StyledOldPrice" data-sentry-source-file="discount-message.tsx">
        {(int, fraction) => int + fraction}
      </StyledOldPrice>{' '}
      <StyledPrice data-sentry-element="StyledPrice" data-sentry-source-file="discount-message.tsx">
        <Price price={discountedPrice} symbol={symbol} data-sentry-element="Price" data-sentry-source-file="discount-message.tsx">
          {(int, fraction) => int + fraction}
        </Price>
        /year
      </StyledPrice>
    </StyledMessage>
    <StyledText data-sentry-element="StyledText" data-sentry-source-file="discount-message.tsx">Learn. Grow. Get hired.</StyledText>
  </StyledCenteredContent>;